import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { PageWrapperComponent } from 'app/components/ui-kit/page-components/page-wrapper/page-wrapper.component';
import { HeavyHeaderComponent } from 'app/components/ui-kit/typography/heavy-header/heavy-header.component';
import { BaseInputComponent } from 'app/components/ui-kit/inputs/base-input/base-input.component';
import { PrimaryBtnComponent } from 'app/components/ui-kit/buttons/primary-btn/primary-btn.component';
import { AlertMessageComponent } from 'app/components/ui-kit/alerts/alert-message/alert-message.component';
import { UserService } from 'app/services/user.service';
import { InviteService } from 'app/services/invite.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-invite-code',
  standalone: true,
  imports: [
    PageWrapperComponent,
    HeavyHeaderComponent,
    CommonModule,
    FormsModule,
    BaseInputComponent,
    PrimaryBtnComponent,
    AlertMessageComponent
  ],
  templateUrl: './invite-code.component.html',
  styleUrl: './invite-code.component.scss'
})
export class InviteCodeComponent {
  code: string = '';
  error: string | null = null;
  isLoading = false;
  mobileNumber: string | null = null;

  constructor(
    private inviteService: InviteService,
    private userService: UserService,
    private router: Router
  ) { }

  async ngOnInit() {
    const profile = await this.userService.getUserProfile();
    this.mobileNumber = profile?.mobileNumber || null;
  }

  async submit() {
    if (this.isLoading) {
      return;
    }

    this.error = null;
    const code = this.code.trim().toUpperCase();
    this.code = code;
    this.isLoading = true;

    try {
      const profile = await this.userService.getUserProfile();
      const phone = profile?.mobileNumber || this.mobileNumber;
      if (!phone) {
        this.error = 'Verified phone number required';
        return;
      }

      const response = await firstValueFrom(this.inviteService.redeemInvite(code, phone));
      if (response.isPromo && !response.trustIdentities) {
          await this.userService.updateUserProfile({
            inviteCodeValidated: true,
            invitePromoCode: code
          });
      }

      await this.router.navigate([
        response.trustIdentities ? '/onboard/invited-party/aircraft' : '/onboard/invited-party/verify'
      ]);
    } catch (err: any) {
      this.error = err?.error?.error || 'Invalid invite code';
    } finally {
      this.isLoading = false;
    }
  }

  formatPhone(phone: string): string {
    const digits = `${phone || ''}`.replace(/\D/g, '');
    const tenDigit = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

    if (tenDigit.length !== 10) {
      return phone;
    }

    return `(${tenDigit.slice(0, 3)}) ${tenDigit.slice(3, 6)}-${tenDigit.slice(6)}`;
  }
}
